/* eslint-disable camelcase */
/* IMPORTS */
import cropr from "../../../shared/utils/cropr";
import gettext from "../../../shared/utils/gettext";
import { LayerList } from "./LayerList";
import { interpolate } from "../../../shared/utils/legacy";
import moment from "moment";
import React, { useMemo, useState } from "react";
import CFTranslateFunction from "../../translations";
import { DatasetTypes, SelectedMeasurementsObjectTypes } from "./ObjectInterfaces";

/* Assigning the prop types */
interface DatasetListProps {
  dataset: DatasetTypes;
  getCorrectMeasurements: any;
  getDevices: any;
  getDisplayName: any;
  getLayers: any;
  handleToggle: any;
  selectedCropfields: string[];
  selectedMeasurements: SelectedMeasurementsObjectTypes;
  setSelectedMeasurements: any;
}

/* DatasetList Component */
export const DatasetList = ({
  dataset,
  getCorrectMeasurements,
  getDevices,
  getDisplayName,
  getLayers,
  handleToggle,
  selectedCropfields,
  selectedMeasurements,
  setSelectedMeasurements,
}: DatasetListProps) => {
  const [expanded, setExpanded] = useState<boolean>(true);
  const [numOfMeasurements, setNumOfMeasurements] = useState<number>(0);
  const filteredDataset = useMemo(() => {
    const filteredDataset: DatasetTypes = { ...dataset };
    filteredDataset.dataset_measurements = filteredDataset.dataset_measurements!.filter(
      getCorrectMeasurements
    );
    return filteredDataset;
  }, [dataset, getCorrectMeasurements]);
  if (!filteredDataset?.dataset_measurements?.length) return null;

  /* JSX */
  return (
    <div className="card-wrapper js-dataDataset p-2" key={filteredDataset.uuid}>
      <div className="card" style={{ cursor: "pointer" }}>
        <div className="card-body">
          <div
            className="card-content container w-100 p-0"
            onClick={() => {
              handleToggle(expanded, setExpanded, dataset);
            }}
          >
            <div className="row">
              <div className="col-9">
                <span className="font-weight-bold">
                  {filteredDataset.name ||
                    CFTranslateFunction(filteredDataset.data_type) ||
                    filteredDataset.data_type}

                  {moment().diff(moment(filteredDataset.created), "days") === 0 && (
                    <span className="ml-1 badge badge-info"> {gettext("new")}</span>
                  )}
                </span>
              </div>
              <div className="col-3 small text-right">
                {moment(filteredDataset.recording_datetime).format("ll")}
              </div>
            </div>
            <div className="row">
              <div className="col-12">{getDevices(filteredDataset).join(", ")}</div>
            </div>
            <div className="row small">
              <div className="col-10">
                {!cropr.share_mode &&
                  (getLayers(filteredDataset).length === 1
                    ? getLayers(filteredDataset)[0].cropfield.get("name")
                    : interpolate(gettext("%s cropfields"), [
                        getLayers(filteredDataset).length || 0,
                      ])) +
                    ", " +
                    (filteredDataset.dataset_measurements.length === 1
                      ? gettext("1 measurement")
                      : interpolate(gettext("%s measurements"), [numOfMeasurements || 0]))}
              </div>
              <div className="col-2">
                <i className={`fa fa-chevron-${expanded ? "up" : "down"} float-right`} />
              </div>
            </div>
          </div>
          {expanded && (
            <LayerList
              dataset={filteredDataset}
              getDisplayName={getDisplayName}
              layers={getLayers(filteredDataset)}
              selectedCropfields={selectedCropfields}
              selectedMeasurements={selectedMeasurements}
              setSelectedMeasurements={setSelectedMeasurements}
              setNumOfMeasurements={setNumOfMeasurements}
            />
          )}
        </div>
      </div>
    </div>
  );
};
